<template>
    <div :class="[$attrs.class, cardClasses]">
        <div class="tw-relative tw-h-52">
            <div :class="['tw-inset-0 tw-z-30']" 
                :style="cardStyles">
                <div class="tw-flex">
                    <div class="tw-shrink-0 ">
                        <img class="tw-h-52" :src="cardImage" :alt="reward.name">
                    </div>
                        
                    <div class="tw-pr-8 tw-flex tw-items-center tw-text-dark">
                        <div>
                            <h3 class="tw-text-3xl tw-font-black tw-mb-2 tw-leading-none">{{ reward.name }}</h3>
                            <template v-if="selected">
                                <div class="tw-flex tw-items-center tw-justify-start tw-mb-2">
                                    <span class="fa fa-star tw-text-base tw-text-orange-medium tw-mr-2"></span>
                                    <h4 class="tw-text-2xl tw-font-black tw-text-orange-medium tw-uppercase tw-leading-none">APPLIED</h4>
                                    <span class="fa fa-star tw-text-base tw-text-orange-medium tw-ml-2"></span>
                                </div>

                                <TwButton 
                                    cssClass="tw-text-sm tw-bg-orange-medium tw-border-2 tw-border-orange-medium tw-text-white hover:tw-bg-black hover:tw-border-black tw-uppercase tw-font-bold tw-px-4 tw-py-2 tw-transition-all tw-duration-200 tw-rounded-full"
                                    @emit-click="removeReward" 
                                    :isLoading="isLoading"
                                    :isDisabled="false" 
                                    :buttonText="'Remove'"/>
                            </template>
                             <template v-else>
                                <TwButton 
                                    cssClass="tw-text-sm tw-bg-orange-medium tw-border-2 tw-border-orange-medium tw-text-white hover:tw-bg-black hover:tw-border-black tw-uppercase tw-font-bold tw-px-4 tw-py-2 tw-transition-all tw-duration-200 tw-rounded-full"
                                    @emit-click="applyReward" 
                                    :isLoading="isLoading"
                                    :isDisabled="false" 
                                    :buttonText="'Apply'"/>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  </template>
  
  <script setup lang="ts">
    import { ref, onMounted, computed } from 'vue'
    import type RewardInterface from '../../types/Reward'
    import type {PropType} from 'vue';
    
    const emit = defineEmits(['applyReward', 'removeReward'])

    import TwButton from '../../components/TwButton.vue';
  
    const props = defineProps({
      reward: {
        type: (Object as PropType<RewardInterface>),
        default: [],
      },
      isLoading: {
        type: Boolean,
        default: false,
      },
      selected: {
        type: Boolean,
        default: false,
      }
    });

    const cardClasses = computed(() => {
        let card_classes = "tw-h-52 tw-w-full tw-rounded-5xl tw-grow-0 tw-overflow-hidden tw-shadow-2xl";
        if (props.selected) {
            card_classes += ' tw-border-4 tw-border-orange-medium'
        } else {
            card_classes += ' tw-border tw-border-zinc-200'
        }

        return card_classes;
    })

    const cardBackground = computed(() => {
        if (props.reward.reward_image != null && props.reward.reward_image.background != null) {
            return props.reward.reward_image.background
        } else {
            return 'https://s3.amazonaws.com/images.mypiada.com/piada-one/rewards/scoots-bg.jpg'
        }
    })
  
    const cardImage = computed(() => {
        if (props.reward.reward_image != null && props.reward.reward_image.thumb != null) {
            return props.reward.reward_image.thumb
        } else {
            return ''
        }
    })

    const cardStyles = computed(() => {
        return "background-color: #ececec; background-image: url('" + cardBackground.value + "'); background-size: cover; background-position: center; background-repeat: no-repeat;"
    })

    const removeReward = () => {
        emit('removeReward', props.reward)
    }
  
    const applyReward = () => {
        emit('applyReward', props.reward)
    }
  </script>
  